import { useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Home, ArrowRight } from "lucide-react";

export default function NotFoundPage() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const t = setTimeout(() => navigate("/", { replace: true }), 5000);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>404 — Stránka nenalezena · Rebelky</title>
        <meta name="robots" content="noindex,follow" />
      </Helmet>
      <main
        data-testid="not-found-page"
        className="min-h-screen flex items-center justify-center bg-black text-white px-6 overflow-hidden relative"
      >
        {/* Background glow */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-1/4 left-1/4 w-[480px] h-[480px] rounded-full bg-[#FF005A] opacity-20 blur-[120px]" />
          <div className="absolute bottom-1/4 right-1/4 w-[400px] h-[400px] rounded-full bg-[#00E5FF] opacity-15 blur-[120px]" />
        </div>

        <div className="relative z-10 text-center max-w-xl">
          <p
            className="text-xs sm:text-sm tracking-[0.3em] text-[#FF005A] font-bold mb-6"
            data-testid="not-found-label"
          >
            ★ ZTRACENO V REBELKÁCH ★
          </p>
          <h1
            className="text-7xl sm:text-8xl lg:text-[10rem] font-black leading-none"
            style={{
              background: "linear-gradient(180deg,#fff 0%,#FF005A 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
            data-testid="not-found-code"
          >
            404
          </h1>
          <h2 className="text-2xl sm:text-3xl font-bold mt-4 mb-3">
            Tahle stránka neexistuje
          </h2>
          <p className="text-zinc-400 text-sm sm:text-base leading-relaxed mb-2">
            Odkaz <code className="text-[#FF005A] break-all">{location.pathname}</code> nikam nevede.
          </p>
          <p className="text-zinc-500 text-xs sm:text-sm mb-10">
            Za 5 sekund tě přesměrujeme zpátky na úvodní stránku…
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-7 py-3 bg-[#FF005A] hover:bg-[#ff1f72] text-white font-bold rounded-full transition-all hover:scale-[1.03]"
              data-testid="not-found-home-btn"
            >
              <Home className="w-4 h-4" /> Zpátky domů
            </Link>
            <Link
              to="/koncerty"
              className="inline-flex items-center justify-center gap-2 px-7 py-3 border border-white/20 hover:border-[#FF005A] hover:text-[#FF005A] text-white font-bold rounded-full transition-all"
              data-testid="not-found-concerts-btn"
            >
              Nadcházející koncerty <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </main>
    </>
  );
}
